export default [
  {
    path: '/_admin',
    name: 'supplier-admin',
    redirect: { name: 'supplier-admin.manage-products' },
    meta: {
      breadcrumb: 'Administrador',
      menuOptions: {
        title: 'Administración',
      },
    },
    component: {
      render(c) { return c('router-view'); },
    },
    children: [
      {
        path: 'products',
        name: 'supplier-admin.manage-products',
        redirect: { name: 'supplier-admin.manage-products.search' },
        meta: {
          breadcrumb: 'Productos',
          menuOptions: {
            title: 'Productos',
            description: 'En esta sección podrá editar o eliminar sus producto',
          },
        },
        component: {
          render(c) { return c('router-view'); },
        },
        children: [
          {
            path: 'search',
            name: 'supplier-admin.manage-products.search',
            meta: {
              breadcrumb: 'Búsqueda',
              welcomeAlert: `Nuestro motor de Inteligencia Artificial detecto y asoció productos en su perfil en base a su actividad en la plataforma transaccional <strong>UNILINK</strong>.
Acá podrá ver la lista de productos asociados a su empresa, y podrá editarlos o eliminarlos. Una vez que contrate un plan <strong>CAT4MRO</strong> podrá cargar su catálogo.`,
            },
            component: () => import('@/pages/supplier/_admin/manage_products'),
          },
          {
            path: 'create-product/:catalog',
            name: 'supplier-admin.create-product',
            meta: {
              breadcrumb() {
                const storeInfo = this.$store.getters['catalog/currentProductItemInfo'];
                if (!storeInfo) {
                  return 'Producto';
                }

                return 'Nuevo Producto';
              },
            },
            component: () => import('@/pages/supplier/_admin/create_product'),
          },
          {
            path: 'product/:product',
            name: 'supplier-admin.manage-product',
            meta: {
              breadcrumb() {
                const storeInfo = this.$store.getters['catalog/currentProductItemInfo'];
                if (!storeInfo) {
                  return 'Producto';
                }

                return `Producto - ${storeInfo.name}`;
              },
            },
            component: () => import('@/pages/supplier/_admin/manage_product'),
          },
        ],
      },
      {
        path: 'users',
        name: 'supplier-admin.manage-users',
        redirect: { name: 'supplier-admin.manage-users.search' },
        meta: {
          breadcrumb: 'Usuarios',
          menuOptions: {
            title: 'Usuarios',
            description: 'En esta sección podrá editar, activar o bloquear a sus usuarios',
          },
        },
        component: {
          render(c) { return c('router-view'); },
        },
        children: [
          {
            path: 'search',
            name: 'supplier-admin.manage-users.search',
            meta: {
              breadcrumb: 'Búsqueda',
            },
            component: () => import('@/pages/supplier/_admin/manage_users'),
          },
          {
            path: 'user/:user',
            name: 'supplier-admin.manage-users.edit-user',
            meta: {
              breadcrumb() {
                return 'Usuario';
              },
            },
            component: () => import('@/pages/supplier/_admin/manage_user'),
          },
        ],
      },
      {
        path: 'organization/:organization',
        name: 'supplier-admin.manage-organization',
        component: () => import('@/pages/supplier/_admin/manage_organization'),
        meta: {
          breadcrumb: 'Administrar Organización',
        },
      },
    ],
  },
];




// WEBPACK FOOTER //
// ./src/router/routes/supplier_admin.js